import type { INotificationEmailPreferences } from "./notifications.type";

/**
 * REF-6854 (C4): the `readBare` guard for the email-preferences body (`{ canvas_comment_email: boolean }`).
 *
 * TOTAL: it accepts any value — `null`, `""`, a string, an array, an object whose getter throws — and never throws
 * (`readBare` propagates a throwing guard, which would turn a malformed 200 into a rejection and a toast).
 */
export const isEmailPreferences = (value: unknown): value is INotificationEmailPreferences => {
  if (typeof value !== "object" || value === null) return false;
  try {
    return typeof (value as { canvas_comment_email?: unknown }).canvas_comment_email === "boolean";
  } catch {
    return false;
  }
};
